/// <reference lib="dom" />
import * as d3 from "d3";
import type { ChartCtx, ChartGroup, ChartScale } from "../core/chart.ts";

export type ChartAxis = "x" | "y";
export type ChartTickFormat = (scale: ChartScale) => (v: number) => string;

export const Single = <E extends d3.BaseType>(root: ChartGroup, tag: string, cls: string) =>
  root
    .selectAll<E, number>(`:scope > ${tag}.${cls}`)
    .data([0])
    .join(tag)
    .attr("class", cls);

export const ScaleOf = (ctx: ChartCtx, axis: ChartAxis) => (axis === "x" ? ctx.x : ctx.y);

export function ScaleIn(ctx: ChartCtx, axis: ChartAxis, own?: ChartScale): ChartScale {
  const base = ScaleOf(ctx, axis);
  return own ? own.copy().range(base.range()) : base;
}
